import React, { PureComponent } from 'react';
import { Page } from 'react-pdf';
class PageRenderer extends PureComponent {
    render() {
        const { data } = this.props;
        const { numPages, triggerResize, width } = data;
        return (React.createElement("div", { className: "page-1" },
            React.createElement(Page, { width: width, pageNumber: 1, renderAnnotationLayer: false, onLoadError: (error) => console.error(error), onLoadSuccess: (page) => triggerResize() })));
    }
}
export default PageRenderer;
